export const environment = {
  production: true,
  platformUiUrl: 'https://enrich-legacy.groupbycloud.com',
  baseUrl: 'https://enrich-legacy-api.groupbycloud.com',
  baseUrlv2: 'https://enrich-legacy-api-v2.groupbycloud.com',
  searchUrl: 'https://enrich-cors.groupbycloud.com/api/v1',
  theme: 'theme-production',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts